import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import {
  Breadcrumb,
  BreadcrumbButton,
  BreadcrumbDivider,
} from "@fluentui/react-components";
import { Fragment, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PspBreadcrumbProps } from "./PspBreadcrumb.types";

export default function PspBreadcrumb({
  currentPath,
  pathPrefix,
}: PspBreadcrumbProps) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const navigate = useNavigate();
  const { lang } = useContext(PspContext);

  return (
    <>
      <Breadcrumb className="mb-4">
        <BreadcrumbButton onClick={() => navigate(`/${pathPrefix}`)}>
          {translate("home", lang)}
        </BreadcrumbButton>
        {currentPath?.split("/").filter(Boolean).length !== 0 && (
          <BreadcrumbDivider />
        )}
        {currentPath?.split("/").map((pathElement, index) => (
          <Fragment key={`breadcrumb-element-${pathElement}`}>
            <BreadcrumbButton
              key={`path-breadcrumb-element-${pathElement}`}
              onClick={() =>
                navigate(
                  `/${pathPrefix}/${currentPath
                    .split("/")
                    .slice(0, index + 1)
                    .map(encodeURIComponent)
                    .join("/")}`,
                )
              }
            >
              {pathElement}
            </BreadcrumbButton>
            {index !== currentPath.split("/").length - 1 && (
              <BreadcrumbDivider />
            )}
          </Fragment>
        ))}
      </Breadcrumb>
    </>
  );
}
